// Module
var code = "<template>\n  <div class=\"flex flex--align-center gap-1\">\n    <status-dot status.bind=\"status\"></status-dot>\n    ${(utilizationFactor + '%') | emptyDash}\n  </div>\n</template>\n";
// Exports
export default code;